import { Tooltip, Box } from '@frontend/legacy-components';

import type {
  NotificationCircleProps,
  CircleProps,
} from 'modules/notifications/types';

const Circle = ({ showCircle, isCurrent }: CircleProps) => {
  if (showCircle)
    return (
      <Tooltip placement="bottom">
        <Box
          data-testid="notification-circle"
          cursor={isCurrent ? 'pointer' : 'not-allowed'}
          backgroundColor="interaction.main"
          borderRadius="50%"
          height={1}
          width={1}
        >
          &nbsp;
        </Box>
      </Tooltip>
    );

  return <Box height={1} width={1} data-testid="no-notification-circle" />;
};

export const NotificationCircle = ({
  notification,
  isCurrent,
}: NotificationCircleProps) => {
  return (
    <Box paddingTop={1} paddingRight={0.75}>
      <Circle showCircle={!notification.isAcknowledged} isCurrent={isCurrent} />
    </Box>
  );
};
